<nav class="sidebar" [class.collapsed]="collapsed" [class.sidebar--cobalt]="isDistributorSupplier()">

  <!-- Brand / Logo -->
  <div class="sidebar-brand">
    @if (!collapsed) {
      <img
        src="/img/common/logo-transparent.png"
        alt="Sourcing Souk"
        class="sidebar-logo-full"
      />
    } @else {
      <img
        src="/img/common/logo-icon.png"
        alt="SS"
        class="sidebar-logo-icon"
      />
    }
  </div>

  <!-- Navigation -->
  <ul class="sidebar-nav list-unstyled mb-0">
    @for (item of navItems(); track item.route) {
      <li>
        <a
          class="sidebar-item"
          [routerLink]="item.route"
          routerLinkActive="active"
          [title]="collapsed ? item.label : ''"
        >
          <span class="item-icon mdi {{ item.icon }}"></span>
          <span class="item-label">{{ item.label }}</span>
        </a>
      </li>
    }
  </ul>

  <!-- Collapse toggle -->
  <div class="sidebar-collapse-zone">
    <button
      class="sidebar-collapse-btn"
      (click)="toggleSidebar()"
      [title]="collapsed ? 'Expand sidebar' : 'Collapse sidebar'"
      aria-label="Toggle sidebar"
    >
      <span class="mdi mdi-chevron-left collapse-icon"></span>
      <span class="collapse-label">Collapse</span>
    </button>
  </div>

</nav>
